<template>
    <b-modal v-model="show" size="lg" title="БИНО ТУРИ" class="cadastre-building">
        <div class="container-fluid" style="min-height: 500px;max-height: 700px;overflow-y: auto;overflow-x: auto">
            <div class="row">
                <div class="col-12">
                    <b-tabs pills>
                        <b-tab title="МАЪЛУМОТ" active>
                            <div class="row">
                                <div class="col-md-6 col-12 pl-0">
                                    <div class="form-check form-check-radio pull-left pl-0">
                                        <label class="form-check-label">
                                            <input class="form-check-input"
                                                   type="radio" value="Civil"
                                                   v-model="data.buildingType">
                                            <span class="form-check-sign"></span>
                                            Фуқоролик
                                        </label>
                                    </div>
                                    <div class="form-check form-check-radio pull-left">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" value="Industrial"
                                                   v-model="data.buildingType">
                                            <span class="form-check-sign"></span>
                                            Саноат
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12 pl-0">
                                    <div class="form-check form-check-radio pull-left pl-0">
                                        <label class="form-check-label">
                                            <input class="form-check-input"
                                                   type="radio" value="Notorious"
                                                   v-model="data.buildingCategory">
                                            <span class="form-check-sign"></span>
                                            Нотурар
                                        </label>
                                    </div>
                                    <div class="form-check form-check-radio pull-left">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" value="Residential"
                                                   v-model="data.buildingCategory">
                                            <span class="form-check-sign"></span>
                                            Турар
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Кадастр иншоат тури <span class="red">*</span></label>
                                <v-select v-model="data.section" label="name"
                                          :options="cadastreSections"
                                          :filterable="false"
                                          @search="onCadastreSectionSearch"
                                          @search:focus="onCadastreSectionFocus"
                                          :class="{invalid: $v.data.section.$error}"
                                >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                                <div class="red" style="font-size: 12px" v-if="$v.data.section.$error">{{$t("realEstate.validation.cadastreBuildingEdit.section")}}</div>
                            </div>
                            <div class="form-group">
                                <label>Код <span class="red">*</span></label>
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="data.code"
                                        :class="{'is-invalid': $v.data.code.$error}"
                                        @blur="$v.data.code.$touch()"
                                />
                                <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreBuildingEdit.code")}}</div>
                            </div>
                            <div class="form-group">
                                <label>Текст <span class="red">*</span></label>
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="data.name"
                                        :class="{'is-invalid': $v.data.name.$error}"
                                        @blur="$v.data.name.$touch()"
                                />
                                <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingEdit.nameUz")}}</div>
                            </div>
                            <div class="form-group">
                                <label>Текст(ru) <span class="red">*</span></label>
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="data.nameRu"
                                        :class="{'is-invalid': $v.data.nameRu.$error}"
                                        @blur="$v.data.nameRu.$touch()"
                                />
                                <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingEdit.nameRu")}}</div>
                            </div>
                            <div class="form-group">
                                <label>Жадвал маълумоти <span class="red">*</span></label>
                                <input
                                        type="text"
                                        class="form-control"
                                        v-model="data.tableInfo"/>
                            </div>
                            <div class="form-group">
                                <label>Рухсат этилган категориялар</label>
                                <div class="row">
                                    <div class="col-md-1 col-sm-2 col-3" v-for="cbc in cadastreBuildingCategories" :key="cbc.code">
                                        <div class="form-check">
                                            <label class="form-check-label pl-0">
                                                <input class="form-check-input" type="checkbox" v-model="cbc.checked">
                                                <span class="form-check-sign"></span>
                                                {{cbc.name}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <div class="form-check">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox" v-model="data.chooseCategory">
                                            <span class="form-check-sign"></span>
                                            Категорияни танлаш
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-check">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox" v-model="data.totalDepreciation">
                                            <span class="form-check-sign"></span>
                                            Амортизация фоизини киритиш
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="ПАРАМЕТЕРЛАР">
                            <div class="row">
                                <div class="col-md-6 col-12 table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-striped">
                                        <thead>
                                        <tr>
                                            <th width="50px"></th>
                                            <th>Текст</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="cbf in cadastreBuildingFieldsLeft" :key="cbf.id">
                                            <td>
                                                <div class="form-check">
                                                    <label class="form-check-label pl-0">
                                                        <input class="form-check-input" type="checkbox" v-model="cbf.checked">
                                                        <span class="form-check-sign"></span>
                                                    </label>
                                                </div>
                                            </td>
                                            <td>{{cbf.name}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div class="col-md-6 col-12 table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-striped">
                                        <thead>
                                        <tr>
                                            <th width="50px"></th>
                                            <th>Текст</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="cbf in cadastreBuildingFieldsRight" :key="cbf.id">
                                            <td>
                                                <div class="form-check">
                                                    <label class="form-check-label pl-0">
                                                        <input class="form-check-input" type="checkbox" v-model="cbf.checked">
                                                        <span class="form-check-sign"></span>
                                                    </label>
                                                </div>
                                            </td>
                                            <td>{{cbf.name}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="АНИҚЛАШ УСУЛЛАРИ">
                            <div class="row">
                                <div class="col-12 table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th width="10%">Категория</th>
                                            <th width="90%">Критериа</th>
                                            <th width="10%"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="category in checkedCategories" :key="category.code">
                                                <td class="align-top">
                                                    {{category.name}}
                                                </td>
                                                <td class="align-top">
                                                    <div class="row mb-1" v-for="criteria in category.criteria" :key="criteria.index">
                                                        <div class="col-lg-6 col-12 mb-2 mb-lg-0">
                                                            <v-select v-model="criteria.fieldData" label="name"
                                                                      :options="cadastreBuildingFields"
                                                                      :filterable="false">
                                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                            </v-select>
                                                        </div>
                                                        <div class="col-lg-6 col-12 mb-2 mb-lg-0">
                                                            <template v-if="criteria.fieldData && criteria.fieldData.type">
                                                                <template v-if="criteria.fieldData.type === 'TEXT'">
                                                                    <input type="text" class="form-control" v-model="criteria.value" />
                                                                </template>
                                                                <template v-else-if="criteria.fieldData.type === 'INTEGER'">
                                                                    <div class="row">
                                                                        <div class="col-6">
                                                                            <numeric-input v-model="criteria.valueMin"></numeric-input>
                                                                        </div>
                                                                        <div class="col-6">
                                                                            <numeric-input v-model="criteria.valueMax"></numeric-input>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template v-else-if="criteria.fieldData.type === 'DECIMAL'">
                                                                    <div class="row">
                                                                        <div class="col-6">
                                                                            <numeric-input v-model="criteria.valueMin" :precision="2"></numeric-input>
                                                                        </div>
                                                                        <div class="col-6">
                                                                            <numeric-input v-model="criteria.valueMax" :precision="2"></numeric-input>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template v-else-if="criteria.fieldData.type === 'LISTBOX' || criteria.fieldData.type === 'COMBOBOX'">
                                                                    <v-select v-model="criteria.reference" label="name"
                                                                              :options="cadastreBuildingFieldReferences[criteria.fieldData.reference.code]"
                                                                              :filterable="false">
                                                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                                    </v-select>
                                                                </template>
                                                                <template v-else-if="criteria.fieldData.type === 'DATE_PICKER'">
                                                                    <datepicker class="form-control" format="dd/MM/yyyy" v-model="criteria.date"></datepicker>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="align-top">
                                                    <button class="all-btn pull-right" @click="addCriteriaItem(category.criteria)">+</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="АМОРТИЗАЦИЯ">
                            <div class="row">
                                <div class="col-12 table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th width="5%"></th>
                                                <th width="25%">ПАРАМЕТЕР</th>
                                                <th v-for="c in checkedCategories" :key="c.code">{{c.name}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="cbdf in cadastreBuildingDepreciationFields" :key="cbdf.id">
                                                <td>
                                                    <div class="form-check">
                                                        <label class="form-check-label pl-0">
                                                            <input class="form-check-input" type="checkbox" v-model="cbdf.checked">
                                                            <span class="form-check-sign"></span>
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>{{cbdf.name}}</td>
                                                <td v-for="c in checkedCategories" :key="c.code" class="align-top" style="min-width: 75px;">
                                                    <numeric-input v-model="cbdf.weights[c.code]"></numeric-input>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="ҚЎШИМЧА">
                            <div class="row">
                                <div class="col-12 table-responsive">
                                    <div class="form-group">
                                        <label>Тикланиш қиймати<span class="red">*</span></label>
                                        <div class="row">
                                            <div class="col-12">
                                                <v-select v-model="recoveryField"
                                                          :options="checkedFields" label="name"
                                                          :filterable="false"
                                                >
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                            </div>
                                            <div class="col-12 table-responsive">
                                              <div class="table-wrapper">
                                                <table class="table table-striped">
                                                    <thead>
                                                    <tr>
                                                        <th v-for="c in checkedCategories" :key="c.code">{{c.name}}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td v-for="c in checkedCategories" :key="c.code" class="align-top">
                                                            <numeric-input v-model="c.recoveryPrice" :precision="3"></numeric-input>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Қўшимча қийматлар</label>
                                        <div class="row">
                                            <div class="col-12 table-responsive">
                                              <div class="table-wrapper">
                                                <table class="table table-striped" style="min-width: 400px;">
                                                    <thead>
                                                        <tr>
                                                            <th width="15%">Код</th>
                                                            <th width="20%">Текст</th>
                                                            <th v-for="c in checkedCategories" :key="c.code">{{c.name}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(additionValue, index) in additionalValues" :key="index">
                                                            <td>
                                                                <input type="text" class="form-control" v-model="additionValue.code"/>
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" v-model="additionValue.name"/>
                                                            </td>
                                                            <td v-for="c in checkedCategories" :key="c.code" class="align-top">
                                                                <numeric-input v-model="additionValue.values[c.code]" :precision="2"></numeric-input>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                              </div>
                                            </div>
                                            <div class="col-12">
                                                <button class="all-btn icon-btn pull-right" @click="addAdditionalValue">+</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Камайтириш қийматлари</label>
                                        <div class="row">
                                            <div class="col-12 table-responsive">
                                              <div class="table-wrapper">
                                                <table class="table table-striped" style="min-width: 400px;">
                                                    <thead>
                                                        <tr>
                                                            <th>Код</th>
                                                            <th>Текст</th>
                                                            <th v-for="c in checkedCategories" :key="c.code">{{c.name}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(reductionValue, index) in reductionValues" :key="index">
                                                            <td>
                                                                <input type="text" class="form-control" v-model="reductionValue.code">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" v-model="reductionValue.name">
                                                            </td>
                                                            <td v-for="c in checkedCategories" :key="c.code" class="align-top">
                                                                <numeric-input v-model="reductionValue.values[c.code]" :precision="2"></numeric-input>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                              </div>
                                            </div>
                                            <div class="col-12">
                                                <button class="all-btn edit-btn icon-btn pull-right" @click="addReductionValue">+</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-12">
                                                <label>
                                                    Капиталлик гурухи <span class="red">*</span>
                                                </label>
                                            </div>
                                            <div class="col-10">
                                                <div class="form-check">
                                                    <label class="form-check-label pl-0">
                                                        <input class="form-check-input" type="checkbox" v-model="data.data.capitalGroupByCategory">
                                                        <span class="form-check-sign"></span> Категориялар буйича
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 table-responsive" v-if="data.data.capitalGroupByCategory">
                                              <div class="table-wrapper" style="min-width: 400px;">
                                                <table class="table table-striped">
                                                    <thead>
                                                    <tr>
                                                        <th v-for="c in checkedCategories" :key="c.code">{{c.name}}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td v-for="c in checkedCategories" :key="c.code" class="align-top">
                                                            <v-select v-model="c.capitalGroup"
                                                                      :options="capitalGroups"
                                                                      :filterable="false">
                                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                            </v-select>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                              </div>
                                            </div>
                                            <div class="col-md-6 col-12" v-else>
                                                <v-select v-model="data.data.capitalGroup"
                                                          :options="capitalGroups"
                                                          :filterable="false"
                                                          :class="{invalid: $v.data.data.capitalGroup.$error}"
                                                >
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                                <div class="red" style="font-size: 12px" v-if="$v.data.data.capitalGroup.$error">{{$t("realEstate.validation.cadastreBuildingEdit.capitalGroup")}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group mt-5">
                                        <div class="row">
                                            <div class="col-md-4 col-12 mb-2 mb-md-0">
                                                <div class="form-check">
                                                    <label class="form-check-label pl-0">
                                                        <input class="form-check-input" type="checkbox" v-model="data.volume.enabled">
                                                        <span class="form-check-sign"></span>
                                                        Хажм оралиқи
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-12 mb-2 mb-md-0">
                                                <numeric-input v-model="data.volume.min" :precision="2" align="center" :disabled="!data.volume.enabled"></numeric-input>
                                            </div>
                                            <div class="col-md-4 col-12 mb-2 mb-md-0">
                                                <numeric-input v-model="data.volume.max" :precision="2" align="center" :disabled="!data.volume.enabled"></numeric-input>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-4 col-12 mb-2 mb-md-0">
                                                <div class="form-check">
                                                    <label class="form-check-label pl-0">
                                                        <input class="form-check-input" type="checkbox" v-model="data.floor.enabled">
                                                        <span class="form-check-sign"></span>
                                                        Қават оралиқи
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-12 mb-2 mb-md-0">
                                                <numeric-input v-model="data.floor.min" :precision="2" align="center" :disabled="!data.floor.enabled"></numeric-input>
                                            </div>
                                            <div class="col-md-4 col-12 mb-2 mb-md-0">
                                                <numeric-input v-model="data.floor.max" :precision="2" align="center" :disabled="!data.floor.enabled"></numeric-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label> Ўзгармас коэффициентлар </label>
                                        <div class="row">
                                            <div class="col-md-6 col-12 pl-0">
                                                <div class="form-check pl-0">
                                                    <label class="form-check-label">
                                                        <input type="checkbox" class="from-check-input" v-model="data.earthquakePointEnabled">
                                                        <span class="form-check-sign"></span>
                                                        Зилзила бардошлилик
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Тикланиш киймати бирлиги</label>
                                        <input type="text" class="form-control" v-model="data.recoveryValueTxt"/>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import {numericTypes} from '@/shared/constants/mask';
    import initFilterModel from '@/shared/filter';
    import {clone, formatDate, parseDate} from '@/shared/utils';
    import {CADASTRE_BULDING_CATEGORIES, CAPITAL_GROUPS} from '@/shared/constants/realEstate';
    import { required, requiredUnless } from 'vuelidate/lib/validators'

    export default {
        name: "CadastreBuildingEditModal",
        components: {
            'b-tabs': bTabs,
            'b-tab': bTab,
            'b-modal': bModal,
            Datepicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                cadastreSectionFilter: initFilterModel(),
                data: {
                    buildingType: 'Civil',
                    buildingCategory: 'Notorious',
                    section: null,
                    code: '',
                    name: '',
                    nameRu: '',
                    tableInfo: '',
                    floor: {
                        enabled: false,
                        min: null,
                        max: null
                    },
                    volume: {
                        enabled: false,
                        min: null,
                        max: null
                    },
                    data: {
                        category: {},
                        recoveryFieldCode: '',
                        capitalGroup: '',
                        capitalGroupByCategory: false
                    },
                    earthquakePointEnabled: false,
                    recoveryValueTxt: ''
                },
                additionalValues: [],
                recoveryField: null,
                capitalGroups: CAPITAL_GROUPS,
                cadastreSections: [],
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: {},
                cadastreBuildingDepreciationFields: [],
                cadastreBuildingCategories: [],
                reductionValues: []
            }
        },
        validations:{
            data:{
                code:{
                    required
                },
                name:{
                    required
                },
                nameRu: {
                    required
                },
                section: {
                    required
                },
                data: {
                    capitalGroup: {
                        required: requiredUnless((vm) => {
                            return !!(vm.capitalGroupByCategory);
                        })
                    }
                }
            }
        },
        computed: {
            cadastreBuildingFieldsLeft() {
                return this.cadastreBuildingFields.filter((field) => {
                    return field.alignment === 1;
                });
            },
            cadastreBuildingFieldsRight() {
                return this.cadastreBuildingFields.filter((field) => {
                    return field.alignment === 2;
                });
            },
            checkedFields() {
                return this.cadastreBuildingFields.filter((field) => {
                    return field.checked;
                });
            },
            checkedCategories() {
                return this.cadastreBuildingCategories.filter((category) => {
                    return category.checked;
                });
            },
            checkedCategoryCodes() {
                return this.cadastreBuildingCategories.filter((category) => {
                    return category.checked;
                }).map((category) => category.code);
            },
            checkedCategorySettings() {
                const settings = {};
                this.cadastreBuildingCategories.forEach((category) => {
                    if (category.checked) {
                        const criteria_data = [];
                        category.criteria.forEach((item) => {
                            if (item.fieldData && item.fieldData.code && item.fieldData.code.length > 0 && item.fieldData.type && item.fieldData.type.length > 0) {
                                const criteria_item = {
                                    field: item.fieldData.code
                                };
                                if (item.fieldData.type === 'TEXT') {
                                    if (item.value && item.value.length > 0) {
                                        criteria_item.value = item.value;
                                    }
                                } else if (item.fieldData.type === 'INTEGER' || item.fieldData.type === 'DECIMAL') {
                                    if (item.valueMin || item.valueMax) {
                                        criteria_item.valueMin = item.valueMin;
                                        criteria_item.valueMax = item.valueMax;
                                    }
                                } else if (item.fieldData.type === 'LISTBOX' || item.fieldData.type === 'COMBOBOX') {
                                    if (item.reference && item.reference.code && item.reference.code.length > 0) {
                                        criteria_item.value = item.reference.code;
                                        criteria_item.valueId = item.reference.id;
                                    }
                                } else if (item.fieldData.type === 'DATE_PICKER') {
                                    if (item.date) {
                                        criteria_item.value = formatDate(item.date);
                                    }
                                }
                                criteria_data.push(criteria_item);
                            }
                        });

                        settings[category.code] = {
                            criteria: criteria_data,
                            recoveryPrice: category.recoveryPrice
                        };
                        if (this.data.data.capitalGroupByCategory) {
                            settings[category.code].capitalGroup = category.capitalGroup;
                        }
                    }
                });
                return settings;
            },
            checkedFieldCodes() {
                const fields = [];
                this.cadastreBuildingFields.forEach((field) => {
                    if (field.checked) {
                        fields.push(field.code);
                    }
                });
                return fields;
            },
            checkedDepreciationCodes() {
                const fields = [];
                this.cadastreBuildingDepreciationFields.forEach((field) => {
                    if (field.checked) {
                        fields.push(field.code);
                    }
                });
                return fields;
            },
            checkedDepreciationFieldCategoryWeights() {
                const field_category_settings = {};
                const categoryCodes = this.checkedCategoryCodes;
                this.cadastreBuildingDepreciationFields.forEach((field) => {
                    const settings = {};
                    if (field.checked) {
                        categoryCodes.forEach(function (categoryCode) {
                            settings[categoryCode] = field.weights[categoryCode];
                        });
                        field_category_settings[field.code] = settings;
                    }
                });
                return field_category_settings;
            }
        },
        methods: {
            init(data) {
                const vm = this;
                this.$http.get('cadastre/building/init')
                    .then(res => {
                        vm.initResponse(res);
                        vm.initData(data);
                    }, err => {
                        console.log(err);
                    });
            },
            initResponse(res) {
                const data = res.data;
                this.cadastreBuildingFieldReferences = data.references;
                this.cadastreBuildingFields = data.fields.map((field) => {
                    field.checked = false;
                    if (field.reference && field.reference.code && field.reference.code.length > 0
                        && !this.cadastreBuildingFieldReferences.hasOwnProperty(field.reference.code)) {
                        this.cadastreBuildingFieldReferences[field.reference.code] = [];
                    }
                    return field;
                });
                this.cadastreBuildingDepreciationFields = data.depreciation.map((field) => {
                    field.checked = false;
                    field.weights = {};
                    this.cadastreBuildingCategories.forEach((category) => {
                        field.weights[category.code] = 0;
                    });
                    return field;
                });
                this.cadastreBuildingCategories = CADASTRE_BULDING_CATEGORIES.map((category) => {
                    return {
                        code: category.code,
                        name: category.name,
                        checked: false,
                        criteria: []
                    }
                });
            },
            initData(data) {
                if (!data) {
                    data = {}
                } else {
                    data = clone(data);
                }
                if (!data.data) {
                    data.data = {}
                }
                if (!data.floor) {
                    data.floor = {
                        enabled: false,
                        min: null,
                        max: null
                    };
                }
                if (!data.volume) {
                    data.volume = {
                        enabled: false,
                        min: null,
                        max: null
                    };
                }

                if (data.data.additionalValues && data.data.additionalValues.length > 0) {
                    this.additionalValues = data.data.additionalValues;
                } else {
                    this.additionalValues = [];
                    this.addAdditionalValue();
                }

                if (data.data.reductionValues && data.data.reductionValues.length > 0) {
                    this.reductionValues = data.data.reductionValues;
                } else {
                    this.reductionValues = [];
                    this.addReductionValue();
                }

                let category_codes = [];
                let category_settings_all = {};
                let field_codes = [];
                let depreciation_field_codes = [];
                let depreciation_field_weights = {};
                if (data.data.category) {
                    if (data.data.category.codes && data.data.category.codes.length > 0) {
                        category_codes = data.data.category.codes
                    }
                    if (data.data.category.settings) {
                        category_settings_all = data.data.category.settings
                    }
                }
                if (data.data.fields && data.data.fields.length > 0) {
                    field_codes = data.data.fields;
                }
                if (data.data.depreciation) {
                    if (data.data.depreciation.codes && data.data.depreciation.codes.length > 0) {
                        depreciation_field_codes = data.data.depreciation.codes;
                    }
                    if (data.data.depreciation.weights) {
                        depreciation_field_weights = data.data.depreciation.weights;
                    }
                }
                this.cadastreBuildingCategories.forEach((category) => {
                    let settings = {};
                    let category_criteria_settings = [];
                    if (category_settings_all.hasOwnProperty(category.code)) {
                        settings = category_settings_all[category.code];
                        if (settings.criteria && settings.criteria.length > 0) {
                            settings.criteria.forEach((criteria) => {
                                criteria.fieldData = this.getFieldByCode(criteria.field);
                                if (criteria.fieldData
                                    && (criteria.fieldData.type === 'LISTBOX' || criteria.fieldData.type === 'COMBOBOX')
                                    && criteria.fieldData.reference && criteria.fieldData.reference.code) {
                                    criteria.references = this.cadastreBuildingFieldReferences[criteria.fieldData.reference.code];
                                    criteria.reference = this.getReferenceByCode(criteria.references, criteria.value);
                                } else {
                                    criteria.references = [];
                                }
                                if (criteria.fieldData && criteria.fieldData.type === 'DATE_PICKER') {
                                    criteria.date = parseDate(criteria.value);
                                }
                            });
                            category_criteria_settings = settings.criteria;
                        }
                    }
                    if (category_criteria_settings.length === 0) {
                        this.addCriteriaItem(category_criteria_settings);
                    }
                    category.checked = category_codes.includes(category.code);
                    category.criteria = category_criteria_settings;
                    category.recoveryPrice = (settings.recoveryPrice ? settings.recoveryPrice : 0);
                    category.capitalGroup = (settings.capitalGroup ? settings.capitalGroup : '');
                });
                this.cadastreBuildingFields.forEach((field) => {
                    field.checked = field_codes.includes(field.code);
                });
                this.cadastreBuildingDepreciationFields.forEach((field) => {
                    field.checked = depreciation_field_codes.includes(field.code);
                    if (depreciation_field_weights && depreciation_field_weights.hasOwnProperty(field.code)) {
                        field.weights = depreciation_field_weights[field.code];
                    } else {
                        field.weights = {};
                    }
                });
                this.data = data;
                if (this.data.data && this.data.data.recoveryFieldCode && this.data.data.recoveryFieldCode.length > 0) {
                    this.recoveryField = this.getFieldByCode(this.data.data.recoveryFieldCode);
                }
            },
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.data.data.fields = this.checkedFieldCodes;
                this.data.data.category = {
                    codes: this.checkedCategoryCodes,
                    settings: this.checkedCategorySettings
                };
                this.data.data.depreciation = {
                    codes: this.checkedDepreciationCodes,
                    weights: this.checkedDepreciationFieldCategoryWeights
                };
                if (this.recoveryField && this.recoveryField.code) {
                    this.data.data.recoveryFieldCode = this.recoveryField.code;
                }

                this.data.data.additionalValues = this.additionalValues.filter((addVal) => {
                    if (addVal.code && addVal.code.length > 0 && addVal.name && addVal.name.length > 0 && addVal.values && Object.keys(addVal.values).length > 0) {
                        return true;
                    }
                    return false;
                });

                this.data.data.reductionValues = this.reductionValues.filter((reduceVal) => {
                    if (reduceVal.code && reduceVal.code.length > 0 && reduceVal.name && reduceVal.name.length > 0 && reduceVal.values && Object.keys(reduceVal.values).length > 0) {
                        return true;
                    }
                    return false;
                });

                this.$http.post('cadastre/building', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('cadastreBuildingChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            addCriteriaItem(criteria) {
                criteria.push({
                    reference: null
                });
            },
            addAdditionalValue() {
                const data = {
                    code: '',
                    name: '',
                    values: {}
                };
                // this.cadastreBuildingCategories.forEach((category) => {
                //     data.values[category.code] = null;
                // });
                this.additionalValues.push(data);
            },
            onCadastreSectionSearch(searchTxt, loading) {
                loading(true);
                this.cadastreSections = [];
                this.cadastreSectionFilter.search = searchTxt;
                this.$http.post('cadastre/section/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreSections = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreSectionFocus() {
                this.cadastreSections = [];
                this.cadastreSectionFilter.search = '';
                this.$http.post('cadastre/section/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreSections = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getFieldByCode(code) {
                const fields = this.cadastreBuildingFields.filter((field) => {
                    return field.code === code
                });
                return fields.length > 0 ? fields[0] : null;
            },
            getReferenceByCode(fieldReferences, code) {
                const references = fieldReferences.filter((ref) => {
                    return ref.code === code
                });
                return references.length > 0 ? references[0] : null;
            },
            addReductionValue() {
                const data = {
                    code: '',
                    name: '',
                    values: {}
                };

                this.reductionValues.push(data)
            }
        },
        created() {
            this.cadastreSectionFilter.page.size = 1000;
            this.$eventBus.$on('showCadastreBuildingEditModal', (data) => {
                this.init(data);
                this.show = true;
            });
        }
    }
</script>

<style>
    .cadastre-building .modal-dialog {
        max-width: 1100px;
        width: 1100px !important;
    }
    .cadastre-building .modal-content {
        width: 1100px !important;
    }
</style>
